export const REGEX_MATCH_EMAIL = `^(?:[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])$`;
export const REGEX_MATCH_EMAIL_INSENSITIVE = new RegExp(REGEX_MATCH_EMAIL, 'i');

export const REGEX_SIREN = `^(?:\s*\ *[0-9]){9}$`;
export const REGEX_UUID =
  /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}/;
export const REGEX_IMAGE_FILE_EXTENSION = /\.(jpg|jpeg|png|gif)$/;

export const escapeSpecialCharacters = (string) => string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

export const CHECK_IF_INTEGER_REGEXP = /^\d+$/gm;
